export default __webpack_public_path__ + "static/media/new2.1d5147ef.JPG";